import React, { useCallback, useEffect } from "react";
import { useTheme } from "@mui/material";
import CheckCircleRounded from "@mui/icons-material/CheckCircleRounded";
import { useCookies } from "react-cookie";
import StatusScreen from "./StatusScreen";

const CheckoutSuccess = () => {
    const theme = useTheme();
    const [cookies] = useCookies(["uuid"]);

    useEffect(() => {
        if (!cookies.uuid) {
            window.location.href = "/creation/signup";
        }
    }, [cookies]);

    const onNext = useCallback(() => {
        if (!cookies.uuid) return;
        window.location.href = "/";
    }, [cookies]);

    return (
        <StatusScreen
            icon={CheckCircleRounded}
            iconColor={theme.palette.success.main}
            title="Payment Successful"
            subtitle="Your subscription has been updated. Thank you for sticking with us!"
            buttonLabel="Go to Dashboard"
            onButtonClick={onNext}
        />
    );
};

export default CheckoutSuccess;
